const EE_EVENTS = {
  CHECKOUT: 'EEcheckout',
  TRANSACTION: 'EEtransaction',
};

const EVENTS = {
  SMS_CHECKBOX: 'SMS Marketing Checkbox',
  SMS_PHONE_NUMBER: 'SMS Marketing Phone Number',
};

const EVENT_ACTIONS = {
  CHECKED: 'Checked',
  UNCHECKED: 'Unchecked',
  VALID_PHONE_NUMBER: 'Valid Phone Number',
};

const EVENT_CATEGORY = 'Checkout';

const AMPLITUDE = {
  SESSION_REPLAY_PROP: '[Amplitude] Session Replay ID',
};

export { AMPLITUDE, EE_EVENTS, EVENTS, EVENT_CATEGORY, EVENT_ACTIONS };

export default EE_EVENTS;
